"use client";

import type { StudentCoBrandPayload } from "@/lib/partnerBranding";

type Props = {
  branding: StudentCoBrandPayload;
  /** When false, omit top chrome (e.g. report has its own header block). */
  showBar?: boolean;
};

export default function PartnerCoBrandChrome({ branding, showBar = true }: Props) {
  if (!branding.active) return null;

  const title = branding.brand_name || branding.partner_display_name;

  if (!showBar) return null;

  return (
    <header className="border-b border-slate-800/80 bg-slate-900/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <div className="flex min-w-0 items-center gap-3">
          {branding.logo_url ? (
            <>
              {/* eslint-disable-next-line @next/next/no-img-element -- partner URLs are arbitrary; avoid remotePatterns churn */}
              <img
                src={branding.logo_url}
                alt=""
                className="h-9 max-w-[180px] object-contain object-left"
              />
              <span className="truncate text-sm font-semibold text-slate-100">{title}</span>
            </>
          ) : (
            <span className="truncate font-heading text-lg font-semibold tracking-tight text-slate-100">
              {title}
            </span>
          )}
        </div>
        <p className="text-[10px] font-medium tracking-wide text-slate-500">Powered by Aptinomic</p>
      </div>
    </header>
  );
}
